









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class App extends Vue {
    private infoBoxVisible!: boolean;

    private data() {
        return {
            infoBoxVisible: false,
        };
    }

    private created() {
        if (this.$store.state.personal.lang !== 'browser') {
            this.$i18n.locale = this.$store.state.personal.lang;
        }
        document.documentElement.style.setProperty('--theme-color', this.$store.state.colors.mainColor);
        document.documentElement.style.setProperty('--accent-color', this.$store.state.colors.accentColor);
    }

    @Watch('$store.state.infoBoxText')
    private onPropertyChanged(value: string, oldValue: string) {
        if (this.$store.state.infoBoxText !== '') {
            this.infoBoxVisible = true;
            setTimeout(() => { 
                this.infoBoxVisible = false; 
                this.$store.state.infoBoxText = '';
            }, 3000);
        }
    }
}
